import { BomPartType } from 'bom/enums';
import { IBomPart } from 'bom/types';

import { PartTypeComponentContent } from './PartTypeComponentContent';
import { PartTypePartContent } from './PartTypePartContent';

interface IProps {
  bomPart: IBomPart;
  onPartNumberClick?: (bomPart: IBomPart) => void;
  onEditPartLineClick?: () => void;
  isEditable?: boolean;
  isDeleted?: boolean;
}

export const PartContent = ({
  bomPart,
  onPartNumberClick,
  onEditPartLineClick,
  isEditable,
  isDeleted,
}: IProps) => {
  switch (bomPart.type) {
    case BomPartType.PART:
      return (
        <PartTypePartContent
          bomPart={bomPart}
          onPartNumberClick={onPartNumberClick}
          isDeleted={isDeleted}
        />
      );
    case BomPartType.COMPONENT:
      return (
        <PartTypeComponentContent
          onEditPartLineClick={onEditPartLineClick}
          isEditable={isEditable}
          isDeleted={isDeleted}
        />
      );
    default:
      return <></>;
  }
};

export default PartContent;
